import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '../../../../../../BaseComponents';
import { useNextSegment } from '@features/seat-map/next-segment';
const NextSegmentButton = () => {
    const { t } = useTranslation('SeatMap');
    const { onNextSegment } = useNextSegment();
    return (React.createElement(BaseButton, { variant: "smallPrimary", onClick: onNextSegment }, t('Next Flight')));
};
export default NextSegmentButton;
